"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_sLURy","tmhk-circular-progress-rotating":"CircularProgress_1DTLQ"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_1DTLQ { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_sLURy { animation: CircularProgress_1DTLQ 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;